import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";

export interface CloseConvertLead extends GtagEvent {
    currency:ISO_4217;
    value: number;
}
export const close_convert_lead = ($_:CloseConvertLead) => event('close_convert_lead',$_);